import { type GenericDetailQueryKey, generateDetailQueryKey } from '@pba/react-query';

import { communitiesFeatureKey } from '../key';
import type { CommunityDetailQueryFilter } from './types';

type CommunityDetailQueryType = GenericDetailQueryKey<CommunityDetailQueryFilter>;

export const getCommunityDetailQueryKey = generateDetailQueryKey({
  prefix: communitiesFeatureKey,
})<CommunityDetailQueryType>;
